import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus_sleeping from '@devices/settings/device_settings/networks_gen_2_plus_sleeping.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import presence_sensor_configuration from '@devices/settings/device_settings/presence_sensor/presence_sensor_configuration.js';
import presence_sensor_fine_tuning from '@devices/settings/device_settings/presence_sensor/presence_sensor_fine_tuning.js';
import presence_sensor_led from '@devices/settings/device_settings/presence_sensor/presence_sensor_led.js';
import sensor_settings_gen_4_plug_us from '@devices/settings/device_settings/sensor_settings_gen_4_plug_us';

export default {
	name: 'ShellyPresence',
	friendly_name: 'Presence',
	family: 'sensor',
	isRadar: true,
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				schedule_gen_2,
				sensor_settings_gen_4_plug_us,
				webhooks_gen_2,
				networks_gen_2_plus_sleeping,
				bluetooth_gen_2,
				virtual_components,
				app,
				share,
				{
					title: 'settings',
					components: [
						presence_sensor_configuration,
						presence_sensor_fine_tuning,
						presence_sensor_led,
						{ title: 'device_name', component: 'device_name' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'location_g2',
						},
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
